module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_90-822f4cc656e4bb303bdeb7b07de1b28f.png";